import { AxiosResponse } from 'axios';
export const handleGqlResponse = (
  response:
    | AxiosResponse<Record<string, Record<string, string>>, unknown>
    | undefined,
  operationName: string
) => {
  if (!response) {
    throw new Error(`An unexpected Error has occurred, Please try again later`);
  } else if (
    response &&
    response.data &&
    response.data[operationName].statusCode != '200'
  ) {
    throw new Error(
      `HTTP error! Status: ${response.data[operationName].statusCode} Message:${JSON.parse(response.data[operationName].message)}`
    );
  }

  return response.data?.[operationName] || [];
};

export const handleClassGqlRes = (
  response:
    | AxiosResponse<Record<string, Record<string, string>>, unknown>
    | undefined,
  operationName: string
) => {
  if (!response || !response.data) {
    throw new Error(
      `An unexpected error has occurred. Please try again later.`
    );
  }

  const operationResponse = response.data[operationName];
  if (!operationResponse) {
    return [];
  }

  const { statusCode, message } = operationResponse;

  if (String(statusCode) !== '200') {
    throw new Error(
      `HTTP error! Status: ${statusCode || 'Unknown'} ${JSON.parse(message)}`
    );
  }

  return operationResponse || [];
};
